import { Injectable } from '@angular/core';
import { HTTPWrapperContext, XHR_STRATEGIES, REQUEST_METHODS, RequestConfigImplementation } from '@ptl/xhr';
import { HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { DobCheckServiceResponse } from './interfaces/dob-check-modal.interface';


@Injectable({
    providedIn: 'root'
  })
export class DobCheckModalService {
    constructor(
        private httpClient: HTTPWrapperContext
    ) { }    

    async validateQuoteAccess(dobEncoded: string, referralId: string): Promise<DobCheckServiceResponse | HttpErrorResponse> {
        const requestConfig = new RequestConfigImplementation({
            method: REQUEST_METHODS.POST,
            url: '/sxesvc/api/v1/referralUpdate/validateQuoteAccess',
            headers: new HttpHeaders({
            }),
            POST_OR_PUT_PAYLOAD: 
            {
                "payload": {
                    "key": dobEncoded,
                    "referralId": referralId
                }
            },
        });

        this.httpClient.setStrategy(XHR_STRATEGIES.AXWAY_PRE_PASS);
        const response: DobCheckServiceResponse | HttpErrorResponse
        = await this.httpClient
        .makeRequest<DobCheckServiceResponse | HttpErrorResponse>(requestConfig)
        .catch( (error: HttpErrorResponse) => {
          return error;
        });
  
      return response;
    }
    
}

